
/** 主表配置 */

const mainTable = {
    buttonSetting: {
        /** 是否允许新增按钮 */
        allowAdd: true,
        addFunctionName: 'saveRowByAddOrEdit',
        beforeAddFunctionName: 'beforeAddViewEdit',
        /** 是否允许编辑按钮 */
        allowEdit: true,
        editFunctionName: 'saveRowByAddOrEdit',
        beforeEditFunctionName: 'beforeAddViewEdit',
        /** 是否允许删除按钮 */
        allowDelete: true,
        deleteFunctionName: 'deleteRows',
        /** 是否允许查看按钮 */
        allowView: true,
        beforeViewFunctionName: 'beforeAddViewEdit'
    },
    header: {
        title: '表单管理',
    },
    table: {
        loading: false,
        maxHeight: 610,
        stripe: true,
        rowStyle: {
            height: '48px;'
        },
        conditionSetting: {
            labelWidth: '120px',
            daterangeWidth: '250px'
        },
        columns: [{
            prop: 'name',
            label: '表单名称',
            isSearchCondition: true,
            type: 'input',
            'placeholder': '请输入表单名称',
            rules: [{ required: true, message: '请输入表单名称', trigger: 'blur' },
                { min: 0, max: 100, message: '长度不超过100个字符', trigger: 'change' }]
        },{
            prop: 'creatorName',
            label: '创建人姓名',
            isSearchCondition: true,
            type: 'input',
            'placeholder': '请输入创建人姓名',
            rules: [{ required: true, message: '请输入创建人姓名', trigger: 'blur' },
                { min: 0, max: 100, message: '长度不超过100个字符', trigger: 'change' }]
        },  {
            prop: 'modelTable',
            label: '数据库表名',
            isSearchCondition: false,
            type: 'input',

        }, {
            prop: 'updateTime',
            label: '更新时间',
            isSearchCondition: false,
            type: 'date',

        }],
        operation: {
            width: '220',
            operations: []
        },
        tableData: [],
        paging: {
            currentPage: 1,
            pageSizes: [10, 15, 20, 25],
            pageSize: 10,
            total: 0
        },
        reload: 'mainTableReload',
        reloadConditions: {

        },
        addDefultValue: {}
    }
}
/** ***************************** 主表配置结束  ***************************** */

export default {
    mainTable

}
